module.exports = __webpack_public_path__ + "static/img/bg1.3e12f4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/sixthAnniveRecall/recall/bg1.png
// module id = kxMw
// module chunks = 1